module.exports = __webpack_public_path__ + "static/Slide03-7c3b1ade0198e980599794921e53fb0d.png";